"use client";
import React, { useEffect, useState } from "react";
import { SetStateAction } from "jotai";
import useAxiosAuth from "@/hooks/fetch/useAxiosAuth";
import { Axios } from "axios";
/**
 *
 * @param fetchFunc function of fetching data it gets axios and setData
 * @param auth default is true and add token if you set false it don't add token to the request
 * @param setAtomData give atom to set data in atom
 * @returns returns state
 */
const useFetch = (
  fetchFunc: (axios: Axios, setData: SetStateAction<any>) => void,
  auth = true,
  atomData: undefined | any = undefined,
  setAtomData: undefined | SetStateAction<any> = undefined,
  sensitive?: any
) => {
  const axiosAuth = useAxiosAuth(auth);
  const [state, setState] = useState({
    data: [],
    loading: true,
    error: null,
  });
  useEffect(() => {
    if (sensitive === undefined) {
      setState({
        data: [],
        loading: true,
        error: null,
      });
      if (atomData !== undefined && setAtomData !== undefined)
        fetchFunc(axiosAuth, setAtomData);
      else fetchFunc(axiosAuth, setState);
    }
  }, []);

  useEffect(() => {
    if (sensitive !== undefined) {
      setState({
        data: [],
        loading: true,
        error: null,
      });
      if (atomData !== undefined && setAtomData !== undefined)
        fetchFunc(axiosAuth, setAtomData);
      else fetchFunc(axiosAuth, setState);
    }
  }, [sensitive]);

  if (atomData !== undefined && setAtomData !== undefined)
    return [atomData, setAtomData] as const;
  else return [state, setState] as const;
};

export default useFetch;
